// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const ChatBotSourceSchema = z.enum(['CUSTOMER','INTERNAL'] as const);

export type ChatBotSourceType = `${z.infer<typeof ChatBotSourceSchema>}`

export default ChatBotSourceSchema;
